import type { ReactNode } from "react";

/**
 * The envelope of a page: the ONE place that decides how wide its content may be, so that two
 * pages of the same kind are the same width whoever wrote them.
 *
 *   list  the console's column (`max-w-page`, 1152 px — the shell draws it): lists, dashboards,
 *         a tenant's page, an editor that has a side panel or a table under it.
 *   form  720 px (`max-w-form`): a page that IS one form, read and filled in at a comfortable
 *         line length.
 *
 * The header and the body share the width, so a form's title and its fields start and end on the
 * same edges. A page never sets a `max-w-*` of its own: it picks a kind. `lint:tokens` counts the
 * ones that still do.
 *
 * `Page` has no slot for the bar of an editing form (`FormActionBar`): the bar goes INSIDE the
 * form, after its card, and sticks to the bottom of the shell's scrolling `<main>` on its own
 * (`position: sticky`), so it takes the form's width and never changes the header, the two widths
 * or the room the page has at its end.
 */
export function Page({ width = "list", children }: { width?: "list" | "form"; children: ReactNode }) {
  return <div className={width === "form" ? "max-w-form" : undefined}>{children}</div>;
}
